import Vue from 'vue';
import Router from 'vue-router';
import BasicLayout from '../layouts/BasicLayout.vue';
import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/ticket_check',
      name: 'ticket_check',
      component: () => import('../views/TicketCheck'),
    },
    {
      path: '/ticket_check_result',
      name: 'ticket_check_result',
      component: () => import('../views/TicketCheckResult'),
    },
    {
      path: '/',
      component: BasicLayout,
      children: [
        {
          path: '/spots_list',
          name: 'spots_list',
          component: () => import('../views/SpotList'),
        },
        {
          path: '/spots_detail/:id',
          name: 'spots_detail',
          component: () => import('../views/TicketsList'),
        },
        {
          path: '/tickets_list',
          name: 'tickets_list',
          component: () => import('../views/TicketsList'),
        },
        {
          path: '/orders_list',
          name: 'orders_list',
          component: () => import('../views/OrdersList'),
        },
        {
          path: '/ticket_detail',
          name: 'ticket_detail',
          component: () => import('../views/TicketDetail'),
        },
        {
          path: '/redirect',
          name: 'redirect',
          component: () => import('../components/Redirect'),
        },
        {
          path: '*',
          redirect: '/redirect',
        },
      ],
    },
    {
      path: '*',
      redirect: '/redirect',
    },
  ],
});

store.dispatch('initializePlatform');

router.afterEach(() => {
  setTimeout(() => {
    store.dispatch('configWechatUrl');
  }, 0);
});

export default router;
